import { useState } from "react";
import { toast } from "sonner";
import client, { formatApiErrorDetail } from "@/lib/api";
import { DateField } from "@/components/form/Fields";
import { formatDate } from "@/lib/format";

// Completed tasks opened from Activities can be backdated so they count in the right KPI period
export function CompletedOn({ record, onSaved }) {
  const [date, setDate] = useState((record.completed_date || "").slice(0, 10));
  const [busy, setBusy] = useState(false);
  const hist = record.completed_date_history || [];
  const save = async (v) => {
    if (!v || v === date) return;
    setBusy(true);
    try {
      const { data } = await client.put(`/actions/${record.id}/completed-date`, { completed_date: v });
      setDate(v); record.completed_date = data.completed_date; record.completed_date_history = data.completed_date_history;
      toast.success(`Completed date set to ${formatDate(v)}`); onSaved && onSaved(data);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-emerald-100 bg-emerald-50/50 p-3" data-testid="task-completed-on">
      <DateField label="Completed on" value={date} onChange={save} testid="task-field-completed-on" />
      <p className="mt-1 text-[11px] text-slate-500">Change this to count the task in an earlier KPI or report period.</p>
      {hist.length > 0 && (
        <ul className="mt-1.5 space-y-0.5 text-[11px] text-slate-500" data-testid="task-completed-history">
          {hist.map((h, i) => <li key={i}>Backdated from {formatDate(h.from)} to {formatDate(h.to)} by {h.by_name || "someone"} on {formatDate(h.at)}</li>)}
        </ul>
      )}
    </div>
  );
}
